module.exports = __webpack_public_path__ + "img/an.d97e9e18.png";